import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import FolderOpenIcon from 'mdi-react/FolderOpenIcon';
import React, { Fragment, memo } from 'react';
import { makeStyles } from '@material-ui/core/styles';

export interface IProps {
  loading: boolean;
  hideButton?: boolean;
  inputRef: any;
  onFileSelected: () => void;
  handleSelectImage: () => void;
  accept?: string;
}

const useStyles = makeStyles({
  progress: {
    marginRight: 5
  }
});

const ButtonStyled = memo((props: IProps) => {
  const { accept = '', hideButton, inputRef, onFileSelected, loading, handleSelectImage } = props;
  const classes = useStyles();

  return (
    <Fragment>
      <input type='file' ref={inputRef} className='hide' onChange={onFileSelected} accept={accept} capture />
      {!hideButton && (
        <Button color='secondary' disabled={loading} onClick={handleSelectImage}>
          {loading ? <CircularProgress className={classes.progress} size={20} /> : <FolderOpenIcon />}
          {loading ? 'Carregando' : 'Selecionar'}
        </Button>
      )}
    </Fragment>
  );
});

export default ButtonStyled;
